import React, { FC } from 'react';
import Edit from 'wix-ui-icons-common/on-stage/Edit';

import { classes } from './EditIcon.st.css';

export const EditIcon: FC = () => <Edit className={classes.root} />;
